export function extractNumericValue(inputString: string) {
  if (!inputString) return inputString;
  // Handle trillions and billions
  const trillionMatch = inputString.match(/(-?\d+\.?\d*)\s*[Tt]rillion/);
  if (trillionMatch) {
    const value = parseFloat(trillionMatch[1]);
    return value * 1000000000000; // Convert to actual number
  }

  const billionMatch = inputString.match(/(-?\d+\.?\d*)\s*[Bb]illion/);
  if (billionMatch) {
    const value = parseFloat(billionMatch[1]);
    return value * 1000000000; // Convert to actual number
  }

  // Remove all non-numeric characters except for '-' and '.'
  const cleanedString = inputString.replace(/[^0-9.-]/g, "");

  // Parse the cleaned string into a floating-point number
  const numericValue = parseFloat(cleanedString);

  if (isNaN(numericValue)) {
    return inputString;
  }

  if (inputString.includes("+")) {
    return numericValue; // Return the numeric value without the positive sign
  }

  return numericValue;
}
